import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Repository } from '@clavisco/core';
import { StorageKeys } from '../enums/storage-keys';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private router: Router) { }

  /**
   * Logs out the current user by deleting the session storage object and navigating to the login page.
   * @param pShouldNavigateToLogin - Indicates whether to navigate to the login page after logging out. Default is true.
   */
  LogOut(pShouldNavigateToLogin: boolean = true): void {
    Repository.Behavior.DeleteStorageObject(StorageKeys.SESSION);

    if(pShouldNavigateToLogin)
    {
      this.router.navigate(['/login']);
    }
  }
}
